export const stepperActionsStyle = {
	wrapper: {
		display: 'flex',
		justifyContent: 'space-between',
	},

	buttonSkip: {
		padding: '10px 16px',
		height: '44px',
	},

	buttonNext: {
		height: '44px',
		fontWeight: 700,

		'& .MuiButton-endIcon': {
			transform: 'rotate(180deg)',
		},
		maxWidth: '250px',
		width: '100%',
	},
};
